import { Flex, Box, Text, Button } from '@pancakeswap/uikit'
import { useTranslation } from '@pancakeswap/localization'
import { Divider } from './styles'

interface RemoveStageProps {
  continueToNextStage: () => void
}

const RemoveStage: React.FC<any> = ({ continueToNextStage }) => {
  const { t } = useTranslation()
  return (
    <>
      <Box p="16px" maxWidth="360px">
        <Text fontSize="24px" bold>
          {t('Delete Protocol')}
        </Text>
        <Text mt="24px" color="textSubtle">
          {t(
            'Use this to delete this Protocol before its next due date. An end date cannot be programmed for deals that you create; you would have to manually delete a deal to stop their owners from continuing to get paid.',
          )}
        </Text>
        <Text mt="16px" color="textSubtle">
          {t('Continue?')}
        </Text>
      </Box>
      <Divider />
      <Flex flexDirection="column" px="16px" pb="16px">
        <Button variant="danger" mb="8px" onClick={continueToNextStage}>
          {t('Delete')}
        </Button>
      </Flex>
    </>
  )
}

export default RemoveStage
